import styled from 'styled-components';
import { pxToRem } from '@quiqupltd/qu-react-sdk/lib/utils/styles';
import { media } from '@quiqupltd/qu-react-sdk/lib/styles/mixins/media';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 15px;
`;

export const H1 = styled.h1`
  font-size: ${pxToRem(20)};
  font-weight: 500;
  margin: 31px 0 6px 0;
  text-align: center;
  line-height: 1.3;
  max-width: 416px;
  color: ${props => props.theme.sky500};
  ${media.up('phone')`
    font-size: ${pxToRem(28)};
    font-weight: 300;
  `};
`;

export const H2 = styled.h2`
  font-size: ${pxToRem(16)};
  font-weight: 300;
  line-height: 1.25;
  text-align: center;
  margin: 0;
  color: ${props => props.theme.grey};

  ${media.up('phone')`
    font-size: ${pxToRem(20)};
    font-weight: 300;
  `};
`;



// WEBPACK FOOTER //
// ./src/app/invalid-token/styles.js